import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={25.701}
    height={19.717}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 18272 14018"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#2b2a29}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="M554 10395h15835v3069c0 304-249 554-554 554H554c-305 0-554-250-554-554v-2515c0-305 249-554 554-554zM12249 8703v-395c0-284 220-516 489-516h1724c270 0 490 232 490 516l1 395h-2704zm-1319-6956c605 0 1094 517 1094 1154 0 638-489 1155-1094 1155-603 0-1092-517-1092-1155 0-637 489-1154 1092-1154zm-3507 0c604 0 1093 517 1093 1154 0 638-489 1155-1093 1155s-1093-517-1093-1155c0-637 489-1154 1093-1154zM4608 6501h706v-953c0-397 309-723 685-723h2820c932 0 1695 806 1695 1791v3201h5875V1593c0-322-249-586-554-586h-1227V0h-663v1007H4608v5494zm-3234 0h2902V1007H1374c-305 0-555 264-555 586v4322c0 322 250 586 555 586zM16888 1115h599c431 0 785 297 785 660v2325c0 362-354 658-785 658h-599V1115z"
        className="fil0"
      />
      <path
        d="M3422 6454v834h699v401h-699v888h357v1309H1853V8577h356V6454z"
        className="fil0"
      />
    </g>
  </svg>
)
export default SvgComponent
